<template>
  <div class="qre" :class="'qre--' + tom" role="status">
    <p class="qre-titulo">
      <i class="fa" :class="icone" aria-hidden="true"></i>
      {{ titulo }}
    </p>

    <p v-if="situacao === 'erro'" class="qre-texto">Confira as ocorrências da entidade no Sapiens antes de responder a regularidade.</p>

    <ul v-if="situacao === 'concluida' && total > 0" class="qre-lista">
      <li v-for="(ocorrencia, i) in entidade" :key="'e' + i">
        <span class="qre-origem">Entidade</span>
        {{ ocorrencia.codoco }} - {{ ocorrencia.desroc }}
        <span v-if="ocorrencia.datger" class="qre-data">desde {{ ocorrencia.datger | moment('L') }}</span>
      </li>
      <li v-for="(ocorrencia, i) in projetos" :key="'p' + i">
        <span class="qre-origem">Projeto {{ ocorrencia.numprj }}</span>
        {{ ocorrencia.codoco }} - {{ ocorrencia.desroc }}
        <span v-if="ocorrencia.datger" class="qre-data">desde {{ ocorrencia.datger | moment('L') }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  /**
   * Quadro informativo para o analista com as ocorrências impeditivas vigentes
   * da entidade no Sapiens (tipo 4 na entidade e tipo 3 nos seus projetos).
   * A consulta é feita pela EditaProposta, que também bloqueia a conclusão.
   */
  export default {
    name: 'quadroRestricoesEntidade',
    props: {
      // { situacao: 'carregando' | 'concluida' | 'erro' | 'dispensada', entidade: [], projetos: [] }
      restricoes: {
        type: Object,
        required: true
      }
    },
    computed: {
      situacao () {
        return this.restricoes.situacao
      },
      entidade () {
        return this.restricoes.entidade || []
      },
      projetos () {
        return this.restricoes.projetos || []
      },
      total () {
        return this.entidade.length + this.projetos.length
      },
      tom () {
        if (this.situacao === 'concluida') {
          return this.total > 0 ? 'impeditiva' : 'regular'
        }
        return this.situacao === 'erro' ? 'erro' : 'neutro'
      },
      icone () {
        return {
          carregando: 'fa-spinner fa-spin',
          erro: 'fa-exclamation-triangle',
          dispensada: 'fa-info-circle',
          concluida: this.total > 0 ? 'fa-ban' : 'fa-check-circle'
        }[this.situacao] || 'fa-info-circle'
      },
      titulo () {
        if (this.situacao === 'carregando') {
          return 'Consultando ocorrências impeditivas da entidade no Sapiens...'
        }
        if (this.situacao === 'erro') {
          return 'Não foi possível consultar as ocorrências impeditivas da entidade.'
        }
        if (this.situacao === 'dispensada') {
          return 'Esta entidade é dispensada da consulta de ocorrências impeditivas.'
        }
        if (this.total === 0) {
          return 'A entidade não possui ocorrências impeditivas vigentes.'
        }
        return this.total === 1
          ? 'A entidade possui 1 ocorrência impeditiva vigente:'
          : `A entidade possui ${this.total} ocorrências impeditivas vigentes:`
      }
    }
  }
</script>

<style scoped>
  .qre {
    border: 1px solid #d2d6de;
    border-left-width: 4px;
    background: #fff;
    padding: 10px 14px;
    margin-bottom: 8px;
  }
  .qre--regular {
    border-left-color: #00a65a;
  }
  .qre--impeditiva {
    border-left-color: #dd4b39;
    background: rgba(221, 75, 57, .05);
  }
  .qre--erro {
    border-left-color: #dd4b39;
  }
  .qre--neutro {
    border-left-color: #3c8dbc;
  }
  .qre-titulo {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin: 0;
  }
  .qre--regular .qre-titulo .fa {
    color: #00a65a;
  }
  .qre--impeditiva .qre-titulo .fa,
  .qre--erro .qre-titulo .fa {
    color: #dd4b39;
  }
  .qre--neutro .qre-titulo .fa {
    color: #3c8dbc;
  }
  .qre-texto {
    font-size: 14px;
    color: #555;
    margin: 6px 0 0;
  }
  .qre-lista {
    margin: 8px 0 0;
    padding-left: 18px;
    font-size: 14px;
    color: #333;
  }
  .qre-lista li {
    margin-top: 4px;
  }
  .qre-origem {
    font-weight: bold;
    margin-right: 4px;
  }
  .qre-data {
    color: #767676;
    font-size: 13px;
    margin-left: 4px;
  }
</style>



// WEBPACK FOOTER //
// quadroRestricoesEntidade.vue?406f414d